import React from "react";
import _ from "lodash";
import { EuiFlexItem } from "@elastic/eui";
import { useIntl } from "react-intl";
import TripDetailsSection from "../TripDetailsSection";

export default function ContractTypeDetails({
    label,
    options,
    contractType,
    onChange,
    isEditable,
}) {
    const intl = useIntl();

    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                options={options}
                // selectedValue={
                //     contractType
                //         ? intl.formatMessage({
                //               id: `contractType.${_.kebabCase(contractType)}`,
                //           })
                //         : ""
                // }
                selectedValue={contractType || ""}
                onSave={onChange}
                isEditable={isEditable}
            />
        </EuiFlexItem>
    );
}
